import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const SINGLE_SLOTS = ["hero", "about", "menu_dish1", "menu_dish2"];

export const useImages = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/images`);
      setImages(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setImages([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const bySlot = (slot) => (Array.isArray(images) ? images.filter((i) => i.slot === slot) : []);
  const one = (slot, fallback = "") => {
    if (!Array.isArray(images)) return fallback;
    const found = images.find((i) => i.slot === slot);
    return found?.src || fallback;
  };

  return { images, loading, refresh, bySlot, one };
};

/**
 * Read a File object as a base64 data URL.
 * Resizes large images to max 1920px width via canvas to keep payloads manageable.
 */
export const fileToCompressedDataUrl = (file, maxWidth = 1920, quality = 0.85) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width > maxWidth ? maxWidth / img.width : 1;
        const w = Math.round(img.width * ratio);
        const h = Math.round(img.height * ratio);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        const mime = file.type === "image/png" ? "image/png" : "image/jpeg";
        const dataUrl = canvas.toDataURL(mime, mime === "image/jpeg" ? quality : undefined);
        resolve(dataUrl);
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
